import { INDEXABLE_EXACT_PATHS, NOINDEX_PATH_PREFIXES } from "./constants";

export type RobotsDirective = "index,follow" | "noindex,nofollow";

/**
 * Returns robots directive for a Next.js pathname (no query string).
 */
export function getRobotsForPath(pathname: string): RobotsDirective {
  const path = pathname.split("?")[0] ?? pathname;

  if ((INDEXABLE_EXACT_PATHS as readonly string[]).includes(path)) {
    return "index,follow";
  }

  if (
    NOINDEX_PATH_PREFIXES.some(
      (prefix) => path === prefix || path.startsWith(`${prefix}/`)
    )
  ) {
    return "noindex,nofollow";
  }

  return "index,follow";
}

export function absoluteUrl(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `https://create.musicfy.lol${normalized === "/" ? "" : normalized}`;
}

/**
 * Public voice URL segment: community models use id; catalog artists use artist name.
 */
export function getVoiceModelIdentifier(model: {
  artist: string;
  id: string;
  isCommunityModel: boolean;
}): string {
  return model.isCommunityModel ? model.id : model.artist;
}

export function getVoiceModelPath(model: {
  artist: string;
  id: string;
  isCommunityModel: boolean;
}): string {
  return `/create/voice/${encodeURIComponent(getVoiceModelIdentifier(model))}`;
}
